import React from 'react';
import { Card, CardBody } from 'reactstrap';

const StatsCard = ({ title, stats, icon, iconColor }) => {
	return (
		<Card className="stats-card-compact">
			<CardBody className="d-flex align-items-center p-3">
				<div className={`stat-icon-wrapper bg-${iconColor}`}>
					<i className={`${icon} stat-icon`}></i>
				</div>
				<div className="stat-content flex-grow-1">
					<div className="stat-title-compact">{title}</div>
					<div className="stat-items-horizontal">
						{stats.map((stat, index) => (
							<div key={index} className="stat-item-horizontal">
								<span className="stat-label-compact">{stat.label}:</span>
								<span className={`stat-value-compact text-${stat.color || 'dark'}`}>
									{stat.value}
								</span>
							</div>
						))}
					</div>
				</div>
			</CardBody>
		</Card>
	);
};

export default StatsCard;
